<template>
    <div class="card shadow-sm mb-4">
        <div class="card-body px-3 pt-lg-5 px-3 px-lg-4">
            <div class="d-flex flex-row align-items-start ">
                <img src="../../assets/images/person.svg" alt="" class="mr-3" style="width: 29px">
                <h3>Account Details</h3>
            
            </div>
            <div class="row" v-if="!showEmailForm">
                <div class="col-12 col-lg-6">
                    <p class="mt-4 float-lg-left"><strong>Email address:</strong> {{ email }}</p>
                    <a href="#" class="mt-lg-4 btn btn-sm btn-outline-info float-lg-right d-block d-md-inline" @click.prevent="showEmailForm = true">Update email</a>
                </div>
            </div>
            <div v-else>
                <div class="form-row" >
                    <div class="col-12 col-lg-6">
                        <div class="form-group">
                            <label for="email">Email address</label>
                            <input type="text" id="email" class="form-control form-control-lg" v-model.trim="$v.email.$model" :class="{'is-invalid' : $v.email.$error || errors.email.length}" >
                            <div class="invalid-feedback" v-if="!$v.email.required">
                                Please enter your email!
                            </div>
                            <div class="invalid-feedback" v-if="!$v.email.email">
                                Please enter a valid email!
                            </div>
                            <div class="invalid-feedback" v-for="(err, key) in errors.email" :key="key">{{ err }}</div>
                        </div>
                    </div>
                    
                </div>
                <div class="form-row">
                    <div class="col-4 col-lg-2">
                        <div class="form-group">
                            <button class="btn btn-outline-info btn-lg btn-block"
                                    @click="showEmailForm = false">Cancel
                            </button>
                        </div>
                    </div>
                    <div class="col-8 col-lg-4">
                        <div class="form-group">
                            <button class="btn btn-success btn-success-gradient btn-lg btn-block"
                                    @click="update" :disabled="running">Update email
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-if="!showPhoneForm">
                <div class="col-12 col-lg-6">
                    <p class="mt-4 float-lg-left"><strong>Phone number:</strong> {{ fullPhone }}</p>
                    <a href="#" class="mt-lg-4 btn btn-sm btn-outline-info float-lg-right d-block d-md-inline" @click.prevent="showPhoneForm = true">Update phone</a>
                </div>
            </div>
            <div v-else>
                <div class="form-row" >
                    <div class="col-12 col-lg-6">
                        <div class="form-group">
                            <label for="email">Phone number</label>
                            <div class="input-group input-group-lg mb-3" :class="{'is-invalid' : $v.phone.$error}">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="phonecode_addon">+44</span>
                                </div>
                                <input type="text" id="phone" class="form-control form-control-lg" aria-describedby="phonecode_addon"
                                       v-model.trim="$v.phone.$model" :class="{'is-invalid' : $v.phone.$error || errors.phone.length}" >
                            </div>
                            <div class="invalid-feedback" v-if="!$v.phone.required">
                                Please enter your phone!
                            </div>
                            <div class="invalid-feedback" v-if="!$v.phone.validPhone">
                                Please enter a valid phone!
                            </div>
                            <div class="invalid-feedback" v-for="(err, key) in errors.phone" :key="key">{{ err }}</div>
                        </div>
                    </div>
        
                </div>
                <div class="form-row">
                    <div class="col-4 col-lg-2">
                        <div class="form-group">
                            <button class="btn btn-outline-info btn-lg btn-block"
                                    @click="showPhoneForm = false">Cancel
                            </button>
                        </div>
                    </div>
                    <div class="col-8 col-lg-4">
                        <div class="form-group">
                            <button class="btn btn-success btn-success-gradient btn-lg btn-block"
                                    @click="updatePhone" :disabled="running">Update phone
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col">
                    <button class="btn btn-lg btn-success btn-success-gradient float-right" @click="$refs.modal.show()">Change password</button>
                </div>
            </div>
        </div>
        <password-change-modal ref="modal"/>
    </div>
</template>

<script>

import {validationMixin} from "vuelidate";
import {email, required} from "vuelidate/lib/validators";
import api from '@/utils/api'
import PasswordChangeModal from "@/components/profile/PasswordChangeModal";

const PhoneNumber = require( 'awesome-phonenumber' );
const validPhone = (value) => {
    if(!value){
        return false;
    }
    let pn =  PhoneNumber(`+44${value}`, 'GB')
    return pn.isValid();
}


export default {
    name: "AccountDetails",
    components: {PasswordChangeModal},
    mixins: [validationMixin],
    data() {
        return {
            showEmailForm: false,
            showPhoneForm: false,
            running: false,
            email: this.$store.getters['auth/email'],
    
            fullPhone: this.$store.getters['auth/phone'],
            phone: this.$store.getters['auth/phone'].replace('+44',''),
            errors: {
                email: [],
                phone: [],
            }
        }
    },
    validations: {
        email: {
            required,
            email
        },
        phone: {
            required,
            validPhone
        },
    },
    methods: {
        update() {
            this.$v.$touch();
            if (this.$v.email.$invalid) {
                return;
            }
        
            let that = this;
            that.running = true;
            api.updateEmail(this.email).then(() => {
                that.$store.commit('auth/email', that.email);
                that.showEmailForm = false;
                that.$toast.success('Email updated successfully!')
            }).catch(error => {
                if (error.response.status === 400 && error.response.data.error.code === 11111) {
                    that.errors.email = error.response.data.meta.email;
                }
            }).finally(() => {
                that.running = false;
            })
            
        },
        updatePhone() {
            this.$v.$touch();
            
            if (this.$v.phone.$invalid) {
                return;
            }
        
            let that = this;
            that.running = true;
            api.updatePhone(!this.phone.startsWith("+44")? `+44${this.phone}` : this.phone).then(() => {
                that.fullPhone = !this.phone.startsWith("+44")? `+44${this.phone}` : this.phone
                that.$store.commit('auth/phone', that.fullPhone);
                that.showPhoneForm = false;
                that.$toast.success('Phone updated successfully!')
            }).catch(error => {
                if (error.response.status === 400 && error.response.data.error.code === 11111) {
                    that.errors.phone = error.response.data.meta.phone;
                }
            }).finally(() => {
                that.running = false;
            })
        }
    },
}
</script>

<style scoped>

</style>
